<template>
  <div>
    <svg
      :style="{
        width: width || '40px',
        height: height || '40px',
      }"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 440.558 440.558"
      style="enable-background: new 0 0 440.558 440.558"
      xml:space="preserve"
    >
      <g>
        <path
          style="fill: #4caf50"
          d="M369.866,234.602c5.042-7.958,10.613-14.132,15.625-18.747
		c-14.515,3.607-27.264,12.852-38.051,27.632c-11.443,15.681-16.266,31.982-16.312,32.144c-0.685,2.355-2.977,3.863-5.41,3.569
		c-2.433-0.298-4.292-2.314-4.389-4.764c-1.838-46.587,9.868-84.52,20.012-108.137c4.753-11.067,9.574-20.064,13.559-26.768
		c-45.506,26.83-66.473,114.643-66.7,115.617c-0.573,2.46-2.897,4.105-5.401,3.837c-2.511-0.269-4.428-2.368-4.467-4.894
		c-0.564-35.909-7.321-60.368-13.863-75.776c1.09,43.273-15.311,106.826-16.176,110.142c-0.627,2.404-2.92,3.985-5.392,3.707
		c-2.469-0.274-4.361-2.32-4.443-4.803c-1.446-43.563-7.824-70.03-12.973-84.64c-6.089,32.799-22.834,66.602-23.672,68.277
		c-0.945,1.893-2.982,2.987-5.081,2.728c-2.102-0.258-3.811-1.81-4.272-3.876c-7.593-34.098-4.099-96.324,16.462-129.857
		c-3.54,1.527-7.619,3.918-11.866,7.654c-11.769,10.354-26.911,33.301-32.218,83.824c-0.262,2.49-2.325,4.403-4.828,4.476
		c-2.492,0.065-4.674-1.719-5.079-4.189c-14.427-88.089-46.942-113.248-65.701-120.38c36.967,47.139,46.959,158.623,49.24,194.225
		c0.165,2.588-1.675,4.873-4.239,5.263c-2.558,0.385-5-1.245-5.61-3.767c-10.206-42.137-29.31-72.206-55.248-86.957
		c-7.735-4.399-14.963-6.827-20.844-8.157c33.231,31.485,42.481,62.271,44.13,83.434c1.262,16.208-1.585,29.057-3.957,36.536
		h267.347C347.491,284.449,358.262,252.919,369.866,234.602z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "GrassIcon",
  props: ["width", "height"],
};
</script>

<style>
</style>